export default {
  SET_SHANTO_IT_INVOICE: function (state, payloads) {
    state.shantoitInvoices = payloads;
  },
}
